export const initialDmn = `
<?xml version="1.0" encoding="UTF-8"?>
  <definitions xmlns="http://www.omg.org/spec/DMN/20151101/dmn.xsd" xmlns:biodi="http://bpmn.io/schema/dmn/biodi/1.0" id="Decision" name="Decision" namespace="http://camunda.org/schema/1.0/dmn">
    <decision id="Decision_1xcomlr" name="Decision"><extensionElements>
    <biodi:bounds x="170" y="300" width="180" height="80" />
    </extensionElements>
    </decision>
  </definitions>
`
